import React, { lazy } from "react";

const Home = lazy(() => import("../Pages/home/Home"));
const About = lazy(() => import("../Pages/about/About"));
const Services = lazy(() => import("../Pages/servicespage/Service"));
const Contact = lazy(() => import("../Pages/contactus/ContactUs"));
const Terms = lazy(() => import("../Pages/terms/Terms"));
const Privacy = lazy(() => import("../Pages/terms/Privacy"));
const Refund = lazy(() => import("../Pages/terms/Refund"));
const BuildXChallenge = lazy(() => import("../Pages/Challenge/BuildXChallenge"));

const menuItems = [
  { path: "/", label: "Home", element: <Home /> },
  { path: "/about", label: "About", element: <About /> },
  { path: "/services", label: "Services", element: <Services /> },
  { path: "/contactus", label: "Contact Us", element: <Contact /> },
  { path: "/terms", label: "Terms of Service", element: <Terms /> },
  { path: "/privacy", label: "Privacy Policy", element: <Privacy /> },
  { path: "/refund", label: "Refund Policy", element: <Refund /> },
  // { path: "/buildx-challenge", label: "Build X Challenge", element: <BuildXChallenge /> },
];
export default menuItems
